import { useLang } from "@/i18n/LanguageContext";
import { useNavigate } from "react-router-dom";

const LOGO_URL = "/logo.png";

export const Footer = ({ handleTabChange }) => {
  const year = new Date().getFullYear();
  const nav = useNavigate();
  const { t } = useLang();
  return (
    <footer className="mt-16 border-t border-border/50 bg-gradient-to-b from-transparent to-secondary/40">
      <div className="w-full px-4 md:px-6 lg:px-10 py-10 grid gap-8 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-3">
            <img src={LOGO_URL} alt="Emlak PRO" className="h-9 w-9 object-contain" />
            <span className="font-display text-lg font-bold">
              <span className="text-brand-teal">Əmlak</span>{" "}
              <span className="text-brand-blue">PRO</span>
            </span>
          </div>
          <p className="text-sm text-muted-foreground max-w-md leading-relaxed">
            {t("common.tagline")}. {t("home.why3Desc")}
          </p>
        </div>
        <div>
          <div className="label-tiny mb-3">{t("nav.search")}</div>
          <ul className="space-y-2 text-sm text-muted-foreground cursor-pointer">
            <li className="cursor-pointer" onClick={() => handleTabChange('web')}>{t("nav.home")}</li>
            <li className="cursor-pointer" onClick={() => handleTabChange('favorites')}>{t("nav.favorites")}</li>
            <li className="cursor-pointer" onClick={() => handleTabChange('popular')}>{t("nav.popular")}</li>
          </ul>
        </div>
        <div>
          <div className="label-tiny mb-3">©2016 - {year}</div>
          <p className="text-sm text-muted-foreground">Əmlak PRO</p>
        </div>
      </div>
    </footer>
  );
};
